import React from 'react'
import * as AntD from 'antd'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Breadcrumb = styled(AntD.Breadcrumb)`
  flex: 1 1 auto;
`

type BreadcrumbArrayItemProps = {
  children?: React.ReactNode
  loading?: boolean
  href?: string | null
}

export function BreadcrumbArrayItem({
  children = '',
  loading = false,
  href = null
}: BreadcrumbArrayItemProps) {
  const Content = () => (href ? <Link to={href}>{children}</Link> : children)

  if (loading) {
    return <AntD.Spin size="small" />
  }
  return <>{Content()}</>
}
